export const API_DOCS_DOMAINS = [
  "api-docs.hoppscotch.io",
  "api-docs.deploychan.hoppscotch.com",
]

export const isDefaultCloudInstance =
  window.location.hostname === "hoppscotch.io" ||
  // Cloud local instance
  window.location.hostname === "localhost" ||
  window.location.hostname === "default.hoppscotch.io" ||
  // Cloud staging instance
  window.location.hostname === "cloud-staging.deploychan.hoppscotch.com" ||
  // Cloud orgs staging instance
  window.location.hostname === "cloud-orgs-staging.deploychan.hoppscotch.com" ||
  // API Docs instances
  API_DOCS_DOMAINS.includes(window.location.hostname)

export const getOrganizationDomain = () => {
  if (isDefaultCloudInstance) {
    return null
  }

  return window.location.hostname.split(".")[0]
}

export const getRootDomain = () => {
  const hostname = window.location.hostname

  // For default cloud instances, return empty string (they are the root)
  if (isDefaultCloudInstance) {
    // Special case: default.hoppscotch.io should return itself as root
    if (hostname === "default.hoppscotch.io") {
      return "default.hoppscotch.io"
    }
    return ""
  }

  // For organization subdomains, extract the root domain
  return hostname.split(".").slice(1).join(".")
}
